<template>
  <div class="art-grid">
    <img
      v-for="(imageGroup, index) in artImages"
      :key="`art-image-${index}`"
      :v-lazy="srcSet('src', imageGroup)"
      :srcset="srcSet('srcset', imageGroup)"
      class="art-image">
  </div>
</template>

<script>
import supportsWebP from 'supports-webp';

import fiascoCover1x from '../assets/images/home/fiascoCover_1x.png';
import fiascoCover2x from '../assets/images/home/fiascoCover_2x.png';
import fiascoCover3x from '../assets/images/home/fiascoCover_3x.png';
import handsome1x from '../assets/images/home/handsome_1x.png';
import handsome2x from '../assets/images/home/handsome_2x.png';
import handsome3x from '../assets/images/home/handsome_3x.png';
import hollywood1x from '../assets/images/home/hollywood_1x.png';
import hollywood2x from '../assets/images/home/hollywood_2x.png';
import hollywood3x from '../assets/images/home/hollywood_3x.png';
import hyper1x from '../assets/images/home/hyper_1x.png';
import hyper2x from '../assets/images/home/hyper_2x.png';
import hyper3x from '../assets/images/home/hyper_3x.png';
import lockedUp1x from '../assets/images/home/lockedUp_1x.png';
import lockedUp2x from '../assets/images/home/lockedUp_2x.png';
import lockedUp3x from '../assets/images/home/lockedUp_3x.png';
import loveRadio1x from '../assets/images/home/loveRadio_1x.png';
import loveRadio2x from '../assets/images/home/loveRadio_2x.png';
import loveRadio3x from '../assets/images/home/loveRadio_3x.png';
import passion1x from '../assets/images/home/passion_1x.png';
import passion2x from '../assets/images/home/passion_2x.png';
import passion3x from '../assets/images/home/passion_3x.png';
import rapaport1x from '../assets/images/home/rapaport_1x.png';
import rapaport2x from '../assets/images/home/rapaport_2x.png';
import rapaport3x from '../assets/images/home/rapaport_3x.png';
import sincerely1x from '../assets/images/home/sincerely_1x.png';
import sincerely2x from '../assets/images/home/sincerely_2x.png';
import sincerely3x from '../assets/images/home/sincerely_3x.png';
import square1x from '../assets/images/home/square_1x.png';
import square2x from '../assets/images/home/square_2x.png';
import square3x from '../assets/images/home/square_3x.png';
import theTrip1x from '../assets/images/home/theTrip_1x.png';
import theTrip2x from '../assets/images/home/theTrip_2x.png';
import theTrip3x from '../assets/images/home/theTrip_3x.png';
import wfft1x from '../assets/images/home/wfft_1x.png';
import wfft2x from '../assets/images/home/wfft_2x.png';
import wfft3x from '../assets/images/home/wfft_3x.png';

import fiascoCover1xwebp from '../assets/images/home/fiascoCover_1x.png.webp';
import fiascoCover2xwebp from '../assets/images/home/fiascoCover_2x.png.webp';
import fiascoCover3xwebp from '../assets/images/home/fiascoCover_3x.png.webp';
import handsome1xwebp from '../assets/images/home/handsome_1x.png.webp';
import handsome2xwebp from '../assets/images/home/handsome_2x.png.webp';
import handsome3xwebp from '../assets/images/home/handsome_3x.png.webp';
import hollywood1xwebp from '../assets/images/home/hollywood_1x.png.webp';
import hollywood2xwebp from '../assets/images/home/hollywood_2x.png.webp';
import hollywood3xwebp from '../assets/images/home/hollywood_3x.png.webp';
import hyper1xwebp from '../assets/images/home/hyper_1x.png.webp';
import hyper2xwebp from '../assets/images/home/hyper_2x.png.webp';
import hyper3xwebp from '../assets/images/home/hyper_3x.png.webp';
import lockedUp1xwebp from '../assets/images/home/lockedUp_1x.png.webp';
import lockedUp2xwebp from '../assets/images/home/lockedUp_2x.png.webp';
import lockedUp3xwebp from '../assets/images/home/lockedUp_3x.png.webp';
import loveRadio1xwebp from '../assets/images/home/loveRadio_1x.png.webp';
import loveRadio2xwebp from '../assets/images/home/loveRadio_2x.png.webp';
import loveRadio3xwebp from '../assets/images/home/loveRadio_3x.png.webp';
import passion1xwebp from '../assets/images/home/passion_1x.png.webp';
import passion2xwebp from '../assets/images/home/passion_2x.png.webp';
import passion3xwebp from '../assets/images/home/passion_3x.png.webp';
import rapaport1xwebp from '../assets/images/home/rapaport_1x.png.webp';
import rapaport2xwebp from '../assets/images/home/rapaport_2x.png.webp';
import rapaport3xwebp from '../assets/images/home/rapaport_3x.png.webp';
import sincerely1xwebp from '../assets/images/home/sincerely_1x.png.webp';
import sincerely2xwebp from '../assets/images/home/sincerely_2x.png.webp';
import sincerely3xwebp from '../assets/images/home/sincerely_3x.png.webp';
import square1xwebp from '../assets/images/home/square_1x.png.webp';
import square2xwebp from '../assets/images/home/square_2x.png.webp';
import square3xwebp from '../assets/images/home/square_3x.png.webp';
import theTrip1xwebp from '../assets/images/home/theTrip_1x.png.webp';
import theTrip2xwebp from '../assets/images/home/theTrip_2x.png.webp';
import theTrip3xwebp from '../assets/images/home/theTrip_3x.png.webp';
import wfft1xwebp from '../assets/images/home/wfft_1x.png.webp';
import wfft2xwebp from '../assets/images/home/wfft_2x.png.webp';
import wfft3xwebp from '../assets/images/home/wfft_3x.png.webp';

export default {
  data() {
    return {
      artImages: {},
    };
  },
  mounted() {
    supportsWebP.then((supported) => {
      if (supported) {
        this.artImages = {
          theTripImgs: [theTrip1xwebp, theTrip2xwebp, theTrip3xwebp],
          wfftImgs: [wfft1xwebp, wfft2xwebp, wfft3xwebp],
          hyperImgs: [hyper1xwebp, hyper2xwebp, hyper3xwebp],
          loveRadioImgs: [loveRadio1xwebp, loveRadio2xwebp, loveRadio3xwebp],
          passionImgs: [passion1xwebp, passion2xwebp, passion3xwebp],
          hollywoodImgs: [hollywood1xwebp, hollywood2xwebp, hollywood3xwebp],
          rapaportImgs: [rapaport1xwebp, rapaport2xwebp, rapaport3xwebp],
          handsomeImgs: [handsome1xwebp, handsome2xwebp, handsome3xwebp],
          fiascoCoverImgs: [fiascoCover1xwebp, fiascoCover2xwebp, fiascoCover3xwebp],
          lockedUpImgs: [lockedUp1xwebp, lockedUp2xwebp, lockedUp3xwebp],
          sincerelyImgs: [sincerely1xwebp, sincerely2xwebp, sincerely3xwebp],
          squareImgs: [square1xwebp, square2xwebp, square3xwebp],
        };
      } else {
        this.artImages = {
          theTripImgs: [theTrip1x, theTrip2x, theTrip3x],
          wfftImgs: [wfft1x, wfft2x, wfft3x],
          hyperImgs: [hyper1x, hyper2x, hyper3x],
          loveRadioImgs: [loveRadio1x, loveRadio2x, loveRadio3x],
          passionImgs: [passion1x, passion2x, passion3x],
          hollywoodImgs: [hollywood1x, hollywood2x, hollywood3x],
          rapaportImgs: [rapaport1x, rapaport2x, rapaport3x],
          handsomeImgs: [handsome1x, handsome2x, handsome3x],
          fiascoCoverImgs: [fiascoCover1x, fiascoCover2x, fiascoCover3x],
          lockedUpImgs: [lockedUp1x, lockedUp2x, lockedUp3x],
          sincerelyImgs: [sincerely1x, sincerely2x, sincerely3x],
          squareImgs: [square1x, square2x, square3x],
        };
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.art-grid {
  display: flex;
  flex-wrap: wrap;
  max-width: 917px;
  margin-top: -36px;
  float: right;
  margin-right: -276px;
  height: 60%;
  @media (max-width: 1324px) {
    max-width: 884px;
    margin-top: -4px;
    margin-right: -404px;
  }
  @media (max-width: 1024px) {
    margin-right: -333px;
    max-width: 713px;
    margin-top: -3px;
  }
  @media (max-width: 870px) {
    margin-right: -374px;
    max-width: 711px;
    margin-top: -3px;
  }
  @media (max-width: 768px) {
    width: 111%;
    margin-top: -47%;
    position: relative;
    margin-right: 0px;
    max-width: none;
    float: none;
  }

  .art-image {
    margin: 0 2% 2% 0;
    width: 21%;
    align-self: center;
    flex: 0 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/ArtGrid.vue